import { SActivityStatus, SCheckbox, SIconButton, SInputLabel, SLegenda, STitleContainer, STitleH3 } from './common/BCommonComponents';
import React, { useContext, useEffect, useState } from 'react';
import AuthContext from './auth/AuthContext';
import { toast } from 'react-toastify';
import { Box, Collapse, FormControl, Grid, IconButton, MenuItem, Paper, Select, Table, TableBody, TableContainer, TableRow, TextField } from '@material-ui/core';
import { HeadCell, Order, STableCell, STableHeader, STableRow } from './common/ScrivaniaTable';
import { ActivityStatus, PrestazioneDTO, PrestazioneFilterDTO, PuntoServizioDTO, TipoPrestazione, UserDTO, UserRole } from './common/Dtos';
import { FaHospital, FaLaptop, FaSearch, IoIosArrowDropdown, IoIosArrowDropup } from 'react-icons/all';
import TablePagination from '@material-ui/core/TablePagination';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import { dateTableFormat, dateToIso } from './common/DateUtils';
import LuxonUtils from '@date-io/luxon';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';

export function Prestazioni() {
	const auth = useContext(AuthContext);
	const [prestazioniList, setPrestazioniList] = useState<PrestazioneDTO[]>([]);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [totalRow, setTotalRow] = useState(0)
	const [order, setOrder] = useState<Order>('asc');
	const [orderBy, setOrderBy] = useState<string>('name');
	const [operatori, setOperatori] = useState<UserDTO[]>([]);
	const [puntiServizioList, setPuntiServizioList] = useState<PuntoServizioDTO[]>([]);
	const [filter, setFilter] = useState<PrestazioneFilterDTO>({
		statoPrestazione: [ActivityStatus.OK, ActivityStatus.KO],
		operatore: 'ALL',
		codicePrestazione: '',
		date: '',
		tipoPrestazione: [TipoPrestazione.BACKOFFICE, TipoPrestazione.FRONTOFFICE],
		puntoServizio: 'ALL'
	})

	const [headCells, setHeadCells] = useState<HeadCell[]>([
		{id: 'tipo', numeric: false, disablePadding: false, label: '', sortable: true},
		{id: 'open', numeric: false, disablePadding: true, label: '', sortable: false},
		{id: 'start_date', numeric: false, disablePadding: true, label: 'DATA', sortable: true},
		{id: 'codice', numeric: false, disablePadding: false, label: 'CODICE PRESTAZIONE', sortable: true},
		{id: 'name', numeric: false, disablePadding: true, label: 'PRESTAZIONE', sortable: true},
		{id: 'note', numeric: false, disablePadding: false, label: 'NOTE ATTIVITA\'', sortable: true},
		{id: 'puntoServizioName', numeric: false, disablePadding: false, label: 'PUNTO DI SERVIZIO', sortable: true},
		{id: 'status', numeric: false, disablePadding: true, label: 'STATO ATTIVITA\'', sortable: true}
	]);

	useEffect(() => {
		getPuntiServizio();
		if (auth.state.roles && (auth.state.roles.indexOf(UserRole.SUPERVISOR) > -1
			|| auth.state.roles.indexOf(UserRole.RESPONSIBLE) > -1
			|| auth.state.roles.indexOf(UserRole.ADMIN) > -1)) {
			getUsers();
			setHeadCells([
				{id: 'tipo', numeric: false, disablePadding: false, label: '', sortable: true},
				{id: 'open', numeric: false, disablePadding: true, label: '', sortable: false},
				{id: 'start_date', numeric: false, disablePadding: true, label: 'DATA', sortable: true},
				{id: 'codice', numeric: false, disablePadding: false, label: 'CODICE PRESTAZIONE', sortable: true},
				{id: 'name', numeric: false, disablePadding: true, label: 'PRESTAZIONE', sortable: true},
				{id: 'note', numeric: false, disablePadding: false, label: 'NOTE ATTIVITA\'', sortable: true},
				//ANONIMIZZAZIONE PRESTAZIONI
				// {id: 'operatore', numeric: false, disablePadding: true, label: 'OPERATORE', sortable: true},
				{id: 'puntoServizioName', numeric: false, disablePadding: false, label: 'PUNTO DI SERVIZIO', sortable: true},
				{id: 'status', numeric: false, disablePadding: true, label: 'STATO ATTIVITA\'', sortable: true}
			]);
		}
	}, [])

	useEffect(() => {
		getAll();
	}, [auth, page, rowsPerPage, order, orderBy]);

	useEffect(() => {

	}, [prestazioniList, totalRow, filter, headCells])

	const getUsers = () => {
		auth.state.axiosInstance?.get('/api/puntoServizio/utenti/' + auth.state.puntoServizioLogged?.id)
			.then(res => {
				setOperatori(res.data)
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero delle Prestazioni!');
				console.log(error);
			})
	}

	const getPuntiServizio = () => {
		if (auth.state.roles && auth.state.roles.indexOf(UserRole.OPERATOR) > -1) {
			auth.state.axiosInstance?.get('/api/puntoServizio/punti_servizio_of_operatore/' + auth.state.id)
				.then(res => {
					setPuntiServizioList(res.data);
				}).catch(error => {
				toast.error('🛑 Errore durante il recupero dei Punti di Servizio!');
				console.log(error);
			});
		} else {
			auth.state.axiosInstance?.get('/api/puntoServizio/punto_servizio_by_cooperativa/' + auth.state.cooperativa + '?login=' + false)
				.then(res => {
					setPuntiServizioList(res.data)
				})
				.catch(error => {
					toast.error('🛑 Errore durante il recupero dei Punti di Servizio!');
					console.log(error);
				})
		}

	}

	const getAll = () => {
		const qs = require('qs');
		auth.state.axiosInstance?.get('/api/prestazione/prestazioni/front_office',
			{
				params: {
					statoPrestazione: [...filter.statoPrestazione],
					operatore: filter.operatore === 'ALL' ? '' : filter.operatore,
					codicePrestazione: filter.codicePrestazione,
					date: dateToIso(filter.date),
					tipoPrestazione: [...filter.tipoPrestazione],
					puntoServizio: filter.puntoServizio === 'ALL' ? '' : filter.puntoServizio,
					page: page,
					size: rowsPerPage,
					sort: orderBy + ',' + order
				},
				paramsSerializer: params => {
					return qs.stringify(params)
				}
			})
			.then(res => {
				setPrestazioniList(res.data.content);
				setTotalRow(res.data.totalElements);
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero delle Prestazioni!');
				console.log(error);
			})
	}

	const handleChangePage = (event: unknown, newPage: number) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleRequestSort = (event: React.MouseEvent<unknown>, property: string) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	const useStyles = makeStyles((theme: Theme) =>
		createStyles({
			formControl: {
				// margin: theme.spacing(1),
				width: '100%',
			},
			selectEmpty: {
				width: '100%',
				margin: '0',
			},
		}),
	);

	const classes = useStyles();

	const handleStausChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const status: string[] = event.target.value === 'ALL' ? [ActivityStatus.OK, ActivityStatus.KO] : [event.target.value as string];
		const newFilter: PrestazioneFilterDTO = {
			statoPrestazione: status,
			operatore: filter.operatore,
			codicePrestazione: filter.codicePrestazione,
			date: filter.date,
			tipoPrestazione: [...filter.tipoPrestazione],
			puntoServizio: filter.puntoServizio
		}
		setFilter(newFilter);
	};

	const handleTipoChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		let newTipo: string[];
		const selected: string[] = event.target.value as string[];

		if (selected.indexOf("ALL") <= -1) {
			newTipo = selected;
		} else {
			newTipo = ["ALL"];
		}

		const newFilter: PrestazioneFilterDTO = {
			statoPrestazione: [...filter.statoPrestazione],
			operatore: filter.operatore,
			codicePrestazione: filter.codicePrestazione,
			date: filter.date,
			tipoPrestazione: newTipo,
			puntoServizio: filter.puntoServizio
		}
		setFilter(newFilter);
	};

	const handleCodiceChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newFilter: PrestazioneFilterDTO = {
			statoPrestazione: [...filter.statoPrestazione],
			operatore: filter.operatore,
			codicePrestazione: event.target.value as string,
			date: filter.date,
			tipoPrestazione: [...filter.tipoPrestazione],
			puntoServizio: filter.puntoServizio
		}
		setFilter(newFilter);
	};

	const handlePuntoServizioChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newFilter: PrestazioneFilterDTO = {
			statoPrestazione: [...filter.statoPrestazione],
			operatore: filter.operatore,
			codicePrestazione: filter.codicePrestazione,
			date: filter.date,
			tipoPrestazione: [...filter.tipoPrestazione],
			puntoServizio: event.target.value as string
		}
		setFilter(newFilter);
	};

	const handleDataChange = (date: MaterialUiPickersDate, value?: string | null) => {
		const newFilter: PrestazioneFilterDTO = {
			statoPrestazione: [...filter.statoPrestazione],
			operatore: filter.operatore,
			codicePrestazione: filter.codicePrestazione,
			date: date ? date?.toString() : '',
			tipoPrestazione: [...filter.tipoPrestazione],
			puntoServizio: filter.puntoServizio
		}
		setFilter(newFilter);
	};

	const handleOperatoreChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newFilter: PrestazioneFilterDTO = {
			statoPrestazione: [...filter.statoPrestazione],
			operatore: event.target.value as string,
			codicePrestazione: filter.codicePrestazione,
			date: filter.date,
			tipoPrestazione: [...filter.tipoPrestazione],
			puntoServizio: filter.puntoServizio
		}
		setFilter(newFilter);
	};

	const handleSearchClick = () => {
		getAll();
	}

	return (
		<div>
			<STitleContainer>
				<STitleH3>Tutte le prestazioni</STitleH3>
			</STitleContainer>
			<Grid container spacing={0} className="w-100 mb-3">
				<Grid item xs={3} className="pr-2">
					<FormControl variant="outlined" className={classes.formControl}>
						<SInputLabel id="canaleAccesso">Stato Attivit&agrave;</SInputLabel>
						<Select
							required
							labelId="staus"
							id="stausSelect"
							className={classes.selectEmpty}
							label="Stato Attività"
							value={(filter.statoPrestazione.length === 1) ?
								filter.statoPrestazione[0] : "ALL"}
							onChange={handleStausChange}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							<MenuItem value={"ALL"} key={"ALL"}>TUTTI</MenuItem>
							<MenuItem value={ActivityStatus.OK} key={ActivityStatus.OK}>{ActivityStatus.OK}</MenuItem>
							<MenuItem value={ActivityStatus.KO} key={ActivityStatus.KO}>{ActivityStatus.KO}</MenuItem>
						</Select>
					</FormControl>
				</Grid>
				<Grid item xs={3} className="px-2">
					<FormControl variant="outlined" className={classes.formControl}>
						<SInputLabel id="canaleAccesso">Tipo Prestazione</SInputLabel>
						<Select
							required
							labelId="type"
							id="typeSelect"
							multiple
							className={classes.selectEmpty}
							label="Tipo Prestazione"
							value={filter.tipoPrestazione}
							renderValue={(selected) => (selected as string[]).join(', ')}
							onChange={handleTipoChange}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							<MenuItem value={TipoPrestazione.BACKOFFICE} key={TipoPrestazione.BACKOFFICE}>
								<SCheckbox checked={filter.tipoPrestazione.indexOf(TipoPrestazione.BACKOFFICE) > -1}/>
								{/*<ListItemText primary={name} />*/}
								{TipoPrestazione.BACKOFFICE}
							</MenuItem>
							<MenuItem value={TipoPrestazione.FRONTOFFICE} key={TipoPrestazione.FRONTOFFICE}>
								<SCheckbox checked={filter.tipoPrestazione.indexOf(TipoPrestazione.FRONTOFFICE) > -1}/>
								{TipoPrestazione.FRONTOFFICE}
							</MenuItem>
							{/*<MenuItem value={TipoPrestazione.MAIL} key={TipoPrestazione.MAIL}>*/}
							{/*	<SCheckbox checked={filter.tipoPrestazione.indexOf(TipoPrestazione.MAIL) > -1}/>*/}
							{/*	{TipoPrestazione.MAIL}*/}
							{/*</MenuItem>*/}
							{/*<MenuItem value={TipoPrestazione.CALL_CENTER} key={TipoPrestazione.CALL_CENTER}>*/}
							{/*	<SCheckbox checked={filter.tipoPrestazione.indexOf(TipoPrestazione.CALL_CENTER) > -1}/>*/}
							{/*	{TipoPrestazione.CALL_CENTER}*/}
							{/*</MenuItem>*/}
						</Select>
					</FormControl>
				</Grid>
				{/*MODIFICA DELL'11/11/2024 anonimizzazione prestazioni*/}
				{/*{auth.state.roles && (auth.state.roles.indexOf(UserRole.SUPERVISOR) > -1*/}
				{/*	|| auth.state.roles.indexOf(UserRole.RESPONSIBLE) > -1*/}
				{/*	|| auth.state.roles.indexOf(UserRole.ADMIN) > -1)&&*/}
				{/*<Grid item xs={3} className="pr-2">*/}
				{/*	<FormControl variant="outlined" className={classes.formControl}>*/}
				{/*		<SInputLabel id="canaleAccesso">Operatore</SInputLabel>*/}
				{/*		<Select*/}
				{/*			required*/}
				{/*			labelId="operatore"*/}
				{/*			id="operatoreSelect"*/}
				{/*			className={classes.selectEmpty}*/}
				{/*			label="Operatore"*/}
				{/*			value={filter.operatore}*/}
				{/*			onChange={handleOperatoreChange}*/}
				{/*			MenuProps={{*/}
				{/*				anchorOrigin: {*/}
				{/*					vertical: "bottom",*/}
				{/*					horizontal: "left"*/}
				{/*				},*/}
				{/*				transformOrigin: {*/}
				{/*					vertical: "top",*/}
				{/*					horizontal: "left"*/}
				{/*				},*/}
				{/*				getContentAnchorEl: null*/}
				{/*			}}*/}
				{/*		>*/}
				{/*			<MenuItem value={"ALL"} key={"ALL"}>TUTTI</MenuItem>*/}
				{/*			{operatori && operatori.map(op => {*/}
				{/*				return (*/}
				{/*					<MenuItem value={op.login} key={op.login}>{op.login}</MenuItem>*/}
				{/*				)*/}
				{/*			})}*/}
				{/*		</Select>*/}
				{/*	</FormControl>*/}
				{/*</Grid>*/}
				{/*}*/}
				<Grid item xs={3} className="pr-2">
					<FormControl variant="outlined" className={classes.formControl}>
						<SInputLabel id="puntoServizio">Punto di Servizio</SInputLabel>
						<Select
							required
							labelId="puntoServizio"
							id="puntoServizioSelect"
							className={classes.selectEmpty}
							label="Punto di Servizio"
							value={filter.puntoServizio}
							onChange={handlePuntoServizioChange}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							<MenuItem value={"ALL"} key={"ALL"}>TUTTI</MenuItem>
							{puntiServizioList && puntiServizioList.map(op => {
								return (
									<MenuItem value={op.id} key={op.id}>{op.name}</MenuItem>
								)
							})}
						</Select>
					</FormControl>
				</Grid>
			</Grid>
			<Grid container spacing={0} className="w-100 mb-3">
				<Grid item xs={3} className="pr-2">
					{/*{new Intl.DateTimeFormat('it-IT').format(new Date())}*/}
					<TextField
						className="w-100"
						id="codice"
						label="Codice Prestazione"
						variant="outlined"
						InputLabelProps={{shrink: true}}
						value={filter.codicePrestazione}
						onChange={handleCodiceChange}
					/>
				</Grid>
				<Grid item xs={3} className="px-2">
					<MuiPickersUtilsProvider utils={LuxonUtils} locale="it-IT">
						<KeyboardDatePicker
							id="date"
							label="Seleziona Data"
							className="w-100"
							variant="inline"
							inputVariant="outlined"
							InputLabelProps={{shrink: true}}
							onChange={handleDataChange}
							format="dd/MM/yyyy"
							okLabel={true}
							error={false}
							value={filter.date}
						/>
					</MuiPickersUtilsProvider>
				</Grid>
				<Grid item xs={1} className="pl-2 d-flex align-items-center">
					<SIconButton onClick={handleSearchClick}><FaSearch className="mx-1"/></SIconButton>
				</Grid>
			</Grid>
			<Grid container spacing={1} className="w-100">
				<Grid item xs={12} className="d-flex justify-content-end mb-3">
					<SLegenda className="color-primary">LEGENDA: </SLegenda>
					<FaLaptop className="color-secondary mx-1" size={20}/> Attivit&agrave; di BackOffice
					<FaHospital className="color-secondary mx-1" size={20}/> Attivit&agrave; di FrontOffice
				</Grid>
			</Grid>
			<Paper>
				<TableContainer>
					<Table
						aria-labelledby="tableTitle"
						size={'medium'}
						aria-label="enhanced table"
					>
						<STableHeader
							numSelected={0}
							order={order}
							orderBy={orderBy}
							onRequestSort={handleRequestSort}
							rowCount={totalRow}
							headCells={headCells}
							addCheckbox={false}
							bgcolor="primary"
							sortable={true}
							disableAction={false}
						/>
						<TableBody>
							{prestazioniList &&
							prestazioniList.map((row, index) => {
								const labelId = `enhanced-table-checkbox-${index}`;
								return (
									<PrestazioneViewRow row={row} labelid={labelId}/>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[5, 10, 25]}
					component="div"
					count={totalRow}
					rowsPerPage={rowsPerPage}
					page={page}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
					labelRowsPerPage={"Risultati per pagina"}
				/>
			</Paper>
		</div>
	);
}

interface RowProps {
	row: PrestazioneDTO;
	labelid: string;
}

function PrestazioneViewRow(props: RowProps) {
	const auth = useContext(AuthContext);
	const {row, labelid} = props;
	const [open, setOpen] = React.useState(false);
	const status = row.status === ActivityStatus.OK ? "Esito Ok"
		: row.status === ActivityStatus.WAIT ? "In Attesa"
			: row.status === ActivityStatus.KO ? "Esito Ko" : "Indefinito";

	const rowHeadCells: HeadCell[] = [
		{id: 'descrizione', numeric: false, disablePadding: false, label: 'DESCRIZIONE', sortable: false},
		{id: 'statoAttivita', numeric: false, disablePadding: false, label: 'STATO ATTIVITA\'', sortable: false},
		{id: 'note', numeric: false, disablePadding: false, label: 'NOTE', sortable: false}
	];

	useEffect(() => {

	}, []);

	return (
		<React.Fragment>
			<STableRow
				hover
				tabIndex={-1}
				key={row.id}
			>
				<STableCell style={{width: '5%', borderBottom: 'none'}} component="th" id={row.id} padding="default" size="small">
					{
						row.type === 'BACKOFFICE' ? <FaLaptop className="color-secondary" size={30}/> : <FaHospital className="color-secondary" size={30}/>
					}
				</STableCell>
				<STableCell style={{width: '5%', borderBottom: 'none'}} component="th" id={labelid} padding="none">
					<IconButton className="color-primary" aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
						{open ? <IoIosArrowDropup size={20}/> : <IoIosArrowDropdown size={20}/>}
					</IconButton>
				</STableCell>
				<STableCell style={{borderBottom: "none"}} padding="none">{dateTableFormat(row.startDate)}</STableCell>
				<STableCell style={{borderBottom: "none"}} padding="default">{row.codice && row.codice !== '' ? row.codice : "-"}</STableCell>
				<STableCell style={{borderBottom: "none"}} padding="none">{row.name}</STableCell>
				<STableCell style={{borderBottom: "none"}} padding="default">{row.description && row.description !== '' ? row.description : "-"}</STableCell>
				{/*11/11/2024 ANONIMIZZAZIONE PRESTAZIONI*/}
				{/*{*/}
				{/*	(auth.state.roles && (auth.state.roles.indexOf(UserRole.SUPERVISOR) > -1*/}
				{/*		|| auth.state.roles.indexOf(UserRole.RESPONSIBLE) > -1*/}
				{/*		|| auth.state.roles.indexOf(UserRole.ADMIN) > -1)) &&*/}
				{/*			<STableCell style={{borderBottom: "none"}} padding="none">{row.operatore}</STableCell>*/}
				{/*}*/}
				<STableCell style={{borderBottom: "none"}} padding="default">{row.puntoServizioName}</STableCell>
				<STableCell style={{borderBottom: "none"}} padding="none">
					<SActivityStatus status={row.status}>{status}</SActivityStatus>
				</STableCell>
			</STableRow>
			<TableRow className="bg-white">
				<TableCell style={{paddingBottom: 0, paddingTop: 0, paddingLeft: 50, paddingRight: 0}} colSpan={12}>
					<Collapse in={open} timeout="auto" unmountOnExit>
						<Box className="mt-3">
							<Table size="small" aria-label="purchases">
								<STableHeader
									numSelected={0}
									rowCount={row.subTask ? row.subTask.length : 0}
									headCells={rowHeadCells}
									addCheckbox={false}
									bgcolor="secondary"
									sortable={false}
									checkboxDisabled={true}
									disableAction={false}
								/>
								<TableBody>
									{row.subTask && row.subTask.map((subTaskRow, index) => {
											const subStatus = subTaskRow.status === ActivityStatus.OK ? "Esito Ok"
												: subTaskRow.status === ActivityStatus.WAIT ? "In Attesa"
													: subTaskRow.status === ActivityStatus.KO ? "Esito Ko" : "Indefinito";

											return (
												<STableRow key={subTaskRow.id}
																	 role="checkbox"
																	 tabIndex={-1}
												>
													<STableCell component="th" scope="row">{subTaskRow.description}</STableCell>
													<STableCell>
														<SActivityStatus status={subTaskRow.status}>{subStatus}</SActivityStatus>
													</STableCell>
													<STableCell component="th" scope="row">{subTaskRow.nota}</STableCell>
												</STableRow>
											);
										}
									)}
								</TableBody>
							</Table>
							<div className="mt-3">
								<h6><b>Note Esito:</b> {row.notaStatus && row.notaStatus !== '' ? row.notaStatus : '-'}</h6>
								<h6><b>Note:</b> {row.note && row.note !== '' ? row.note : '-'}</h6>
							</div>
						</Box>
					</Collapse>
				</TableCell>
			</TableRow>
		</React.Fragment>
	)
}
